var Config = require('../config/Config');
var Constants = require('../constants/Constants');

var Base = require('./Base');
var Api = new Base({
    base_url: Config.ssoApiUrl
});
Api.createRequest = function(method, url, query, params, customHeaders) {
    var token = params.token || false;
    delete params.token;

    var req = Base.prototype.createRequest.call(this, method, url, query, params, customHeaders);

    if (token) {
        req.set('Authorization', 'Bearer ' + token.access_token);
    }

    return req;
};

var Auth = {
    /**
     * Fetches the user related to the token that we received from the OAuth2 server.
     *
     * Returns a promise that will resolve when the user is retrieved.
     */
    getUser: function (token) {
        var url = Api.makeUrl('/me');

        Api.send(Constants.auth_api.GET_USER, 'GET', url, null, { token: token });
    }
};

module.exports = Auth;



// WEBPACK FOOTER //
// ./app/api/Auth.js